import { Tooltip, useTheme } from "@material-ui/core";
import { differenceInSeconds } from "date-fns";
import { shallowEqual, useSelector } from "react-redux";
import DeviceDetector from "device-detector-js";
import moment from "moment";

export const convertHexToRGB = (hex) => {
  // check if it's a rgba
  if (hex.match("rgba")) {
    let triplet = hex.slice(5).split(",").slice(0, -1).join(",");
    return triplet;
  }

  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split("");
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = "0x" + c.join("");

    return [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",");
  }
};

export const checkstringLength = (string, length) => {
  let newStrng;
  if (string && string.length > length) {
    newStrng = string.substring(0, length) + "...";
    return (
      <Tooltip title={string} placement="top">
        <div>{newStrng}</div>
      </Tooltip>
    );
  } else {
    return <div>{string}</div>;
  }
};

export const breakword = (string) => {
  return (
    <span>
      {string.split(" ")[0]}
      <br />
      {string.split(" ")[1]}
    </span>
  );
};

export function capitalizeFirstLetter(string) {
  if (string && string) return string.charAt(0).toUpperCase() + string.slice(1);
}

export function isValidURL(string) {
  var res = string.match(
    /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
  );

  if (res !== null) return true;
}

export const secsToMins = (secs) => {
  var minutes = Math.floor(secs / 60);
  var seconds = secs - minutes * 60;
  let newTime;
  if (seconds > 0) {
    newTime = minutes + " mins" + " " + seconds + " secs";
  } else {
    newTime = minutes + " mins";
  }
  return newTime;
};
export function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    }, wait);
    if (immediate && !timeout) func.apply(context, args);
  };
}

export function isMobile() {
  if (window) {
    return window.matchMedia(`(max-width: 767px)`).matches;
  }
  return false;
}
export function isSmallScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 500px)`).matches;
  }
  return false;
}

export function isMdScreen() {
  if (window) {
    return window.matchMedia(`(max-width: 1199px)`).matches;
  }
  return false;
}

export const useThemeMode = () => {
  const orgInfo = useSelector(
    (state) => state.orgInfo.responseData,
    shallowEqual
  );
  const theme = useTheme();
  if (theme.palette.type === "dark")
    return {
      isDarkMode: true,
      themeColor: "#fff",
    };
  else
    return {
      isDarkMode: false,
      themeColor: `${orgInfo?.colorThemes[1].primary}`,
    };
};

function currentYPosition(elm) {
  if (!window && !elm) {
    return;
  }
  if (elm) return elm.scrollTop;
  // Firefox, Chrome, Opera, Safari
  if (window.pageYOffset) return window.pageYOffset;
  // Internet Explorer 6 - standards mode
  if (document.documentElement && document.documentElement.scrollTop)
    return document.documentElement.scrollTop;
  // Internet Explorer 6, 7 and 8
  if (document.body.scrollTop) return document.body.scrollTop;
  return 0;
}

function elmYPosition(elm) {
  var y = elm.offsetTop;
  var node = elm;
  while (node.offsetParent && node.offsetParent !== document.body) {
    node = node.offsetParent;
    y += node.offsetTop;
  }
  return y;
}

export function scrollTo(scrollableElement, elmID) {
  var elm = document.getElementById(elmID);

  if (!elmID || !elm) {
    return;
  }

  var startY = currentYPosition(scrollableElement);
  var stopY = elmYPosition(elm);

  var distance = stopY > startY ? stopY - startY : startY - stopY;
  if (distance < 100) {
    scrollTo(0, stopY);
    return;
  }
  var speed = Math.round(distance / 50);
  if (speed >= 20) speed = 20;
  var step = Math.round(distance / 25);
  var leapY = stopY > startY ? startY + step : startY - step;
  var timer = 0;
  if (stopY > startY) {
    for (var i = startY; i < stopY; i += step) {
      setTimeout(
        (function (leapY) {
          return () => {
            scrollableElement.scrollTo(0, leapY);
          };
        })(leapY),
        timer * speed
      );
      leapY += step;
      if (leapY > stopY) leapY = stopY;
      timer++;
    }
    return;
  }
  for (let i = startY; i > stopY; i -= step) {
    setTimeout(
      (function (leapY) {
        return () => {
          scrollableElement.scrollTo(0, leapY);
        };
      })(leapY),
      timer * speed
    );
    leapY -= step;
    if (leapY < stopY) leapY = stopY;
    timer++;
  }
  return false;
}

export function getTimeDifference(date) {
  let difference = differenceInSeconds(new Date(), date);

  if (difference < 60) return `${Math.floor(difference)} sec`;
  else if (difference < 3600) return `${Math.floor(difference / 60)} min`;
  else if (difference < 86400) return `${Math.floor(difference / 3660)} h`;
  else if (difference < 86400 * 30)
    return `${Math.floor(difference / 86400)} d`;
  else if (difference < 86400 * 30 * 12)
    return `${Math.floor(difference / 86400 / 30)} mon`;
  else return `${(difference / 86400 / 30 / 12).toFixed(1)} y`;
}

export function generateRandomId() {
  let tempId = Math.random().toString();
  let uid = tempId.substr(2, tempId.length - 1);
  return uid;
}

export function getQueryParam(prop) {
  var params = {};
  var search = decodeURIComponent(
    window.location.href.slice(window.location.href.indexOf("?") + 1)
  );
  var definitions = search.split("&");
  definitions.forEach(function (val, key) {
    var parts = val.split("=", 2);
    params[parts[0]] = parts[1];
  });
  return prop && prop in params ? params[prop] : params;
}

export function classList(classes) {
  return Object.entries(classes)
    .filter((entry) => entry[1])
    .map((entry) => entry[0])
    .join(" ");
}

/**
 * This function get the value of a query string from a url
 *
 * @param {string} queryStringKey
 * @returns string
 */
export const getQueryString = (queryStringKey) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const value = urlParams.get(queryStringKey);
  return value;
};

export const isPrintMedia = () => {
  if (window.matchMedia("print").matches) return true;
  else return false;
};

export const localeTimeStamp = new Date(Date.now()).toLocaleString();

export const browserDetails = () => {
  let ip = localStorage.getItem("ipAddress");
  const deviceDetector = new DeviceDetector();
  const userAgent = navigator.userAgent;
  const device = deviceDetector.parse(userAgent);
  const payload = {
    userDeviceType: `${device.os.name} ${device.os.version}`,
    userBrowserType: device.client.name,
    userIpAddress: JSON.parse(ip),
    userRefererUrl: "",
  };
  return payload;
};

export const config = {
  function(progressEvent) {
    var percentCompleted = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    return percentCompleted;
  },
};

export function convertLocalToUTC(dt, dtFormat) {
  return moment(dt, dtFormat).utc().format("YYYY-MM-DD HH:mm");
}

export function convertUTCToLocal(utcDt, utcDtFormat) {
  var toDt = moment.utc(utcDt, utcDtFormat).toDate();
  return moment(toDt).format("ddd MMM D, YYYY, h:mm A");
}

export const exportPDF = (
  doc,
  orgInfo,
  head,
  body,
  theme,
  pdfName,
  headerName
) => {
  const addFooters = (doc) => {
    const pageCount = doc.internal.getNumberOfPages();

    // doc.setFont("helvetica", "italic");
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#4b4b4b");
    doc.setFontSize(8);
    for (var i = 1; i <= pageCount; i++) {
      doc.setPage(i);
      doc.text(
        `Copyright ©${new Date().getFullYear()} ChurchPad | ${moment().format(
          "MMM D, YYYY h:mm a"
        )}`,
        // 105,
        // 10,
        // null,
        // null,
        // "center"
        doc.internal.pageSize.width / 2,
        doc.internal.pageSize.height.toFixed(0) - 6,
        // 200,
        {
          align: "center",
        }
      );
      doc.text(
        "Page " + String(i) + " of " + String(pageCount),
        // doc.internal.pageSize.width / 2,
        23,
        doc.internal.pageSize.height.toFixed(0) - 6,
        // 200,
        {
          align: "center",
        }
      );
    }
  };
  // var companyImg =
  //   "https://dev.churchpad.com/xTextersImageFilesLoc/1/3/1__1635336077__my.png";
  var companyImg = orgInfo.logo;
  var c = document.createElement("canvas");
  var img = document.createElement("img");
  img.crossOrigin = "anonymous";
  img.src = companyImg;
  // var imgUrl =
  //   "data:image/png;base64,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";
  // var doc = new jsPDF("l");
  setTimeout(() => {
    c.height = img.naturalHeight;
    c.width = img.naturalWidth;
    var ctx = c.getContext("2d");

    ctx.drawImage(img, 0, 0, c.width, c.height);
    var base64String = c.toDataURL("image/png");
    // var base64Img = base64String.replace(/^data:image\/(png|jpg);base64,/, "");
    doc.addImage(base64String, "JPEG", 170, 8, 30, 10);
    // doc.addImage(imgUrl, "JPEG", 15, 8, 30, 10);

    doc.setFontSize(20);
    doc.setTextColor("#2a2a2a");
    doc.setFont("helvetica", "bold");
    doc.text(
      `${orgInfo.fullName}`,
      doc.internal.pageSize.width / 2,
      30,
      null,
      null,
      "center"
    );
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#4b4b4b");
    doc.text(
      `${orgInfo.email} | ${orgInfo.website}`,
      doc.internal.pageSize.width / 2,
      35,
      null,
      null,
      "center"
    );

    doc.setFontSize(14);
    doc.setFont("helvetica", "normal");
    doc.setTextColor("#4b4b4b");
    doc.text(
      `${headerName}`,
      doc.internal.pageSize.width / 2,
      49,
      null,
      null,
      "center"
    );
    doc.autoTable({
      head: [head],
      body,
      startY: 53,
      didParseCell: function (table) {
        if (table.section === "head") {
          table.cell.styles.fillColor = theme.palette.primary.main;
        }
      },
    });
    addFooters(doc);
    doc.save(
      `${orgInfo.fullName.replace(" ", "_")}_${pdfName}_${moment().format(
        "MMM_D_YYYY_hh_mm_a"
      )}`
    );
  }, 1000);
};

export const formatCurrency = (amount) => {
  return Number(amount)
    .toFixed(2)
    .replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

export const Range = (start, end) => {
  return Array(end - start + 1)
    .fill()
    .map((_, idx) => start + idx);
};

export const downloadImg = async (e, downloadImg) => {
  e.preventDefault();
  const originalImage = downloadImg;
  // const originalImage =
  //   "https://cdn1.iconfinder.com/data/icons/ninja-things-1/1772/ninja-simple-512.png";
  const image = await fetch(originalImage);

  //Split image name
  const nameSplit = originalImage.split("/");
  const duplicateName = nameSplit.pop();

  const imageBlog = await image.blob();
  const imageURL = URL.createObjectURL(imageBlog);
  const link = document.createElement("a");
  link.href = imageURL;
  link.download = "" + duplicateName + "";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const getAdminUserId = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.responseData?.userId;
};
export const getUserInfo = () => {
  return JSON.parse(localStorage.getItem("user"));
};

export const dynamicSort = (order, property, obj1 = {}, obj2 = {}) => {
  const months = {
    January: "1",
    February: "2",
    March: "3",
    April: "4",
    May: "5",
    June: "6",
    July: "7",
    August: "8",
    September: "9",
    October: "10",
    November: "11",
    December: "12",
    "": "0",
  };
  const monthsShort = {
    Jan: "1",
    Feb: "2",
    Mar: "3",
    Apr: "4",
    May: "5",
    Jun: "6",
    Jul: "7",
    Aug: "8",
    Sep: "9",
    Oct: "10",
    Nov: "11",
    Dec: "12",
    "": "0",
  };
  let val1, val2;
  switch (property) {
    case "date":
      const [month1, date1 = "0"] = obj1.data.split(" ");
      const [month2, date2 = "0"] = obj2.data.split(" ");
      val1 = parseInt(monthsShort[month1], 10) * 100 + parseInt(date1, 10);
      val2 = parseInt(monthsShort[month2], 10) * 100 + parseInt(date2, 10);
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "month_year":
      const [month1MY, date1MY = "0"] = obj1.data.split(" ");
      const [month2MY, date2MY = "0"] = obj2.data.split(" ");
      val1 =
        parseInt(monthsShort[month1MY], 10) * 100 +
        parseInt(date1MY, 10) * 10000;
      val2 =
        parseInt(monthsShort[month2MY], 10) * 100 +
        parseInt(date2MY, 10) * 10000;
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "daily":
      const [monthD1, dateD1 = "0", year1 = "0"] = obj1.data.split(" ");
      const [monthD2, dateD2 = "0", year2 = "0"] = obj2.data.split(" ");
      val1 =
        parseInt(monthsShort[monthD1], 10) * 100 +
        parseInt(dateD1, 10) +
        parseInt(year1, 10) * 10000;
      val2 =
        parseInt(monthsShort[monthD2], 10) * 100 +
        parseInt(dateD2, 10) +
        parseInt(year2, 10) * 10000;

      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "month":
      val1 = parseInt(months[obj1.data], 10);
      val2 = parseInt(months[obj2.data], 10);
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "number":
      val1 = obj1.data ? parseInt(obj1.data, 10) : "0";
      val2 = obj2.data ? parseInt(obj2.data, 10) : "0";
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "array":
      val1 = obj1.data.length;
      val2 = obj2.data.length;
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "weekly":
      var splitString1 = obj1.data.split(" ");
      var splitString2 = obj2.data.split(" ");
      val1 =
        parseInt(`0.${splitString1[1]}`, 10) +
        parseInt(monthsShort[splitString1[8]], 10) * 100 +
        parseInt(splitString1[9], 10) +
        parseInt(splitString1[10], 10) * 10000;
      val2 =
        parseInt(`0.${splitString2[1]}`, 10) +
        parseInt(monthsShort[splitString2[8]], 10) * 100 +
        parseInt(splitString2[9], 10) +
        parseInt(splitString2[10], 10) * 10000;
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    case "quarterly":
      const quarters = {
        Q1: 0.1,
        Q2: 0.2,
        Q3: 0.3,
        Q4: 0.4,
      };
      let q1 = obj1.data.split("/");
      let q2 = obj2.data.split("/");
      val1 = quarters[q1[0]] + Number(q1[1]);
      val2 = quarters[q2[0]] + Number(q2[1]);
      return (val1 - val2) * (order === "asc" ? 1 : -1);
    default:
      return undefined;
  }
};
// "react-scripts": "5.0.0",

export const getDataForTooltipPerPage = (data, name) => {
  const filteredData = data?.filter((el) => el.name === name);
  return filteredData[0]?.navPages;
};
